import RoundedButton from 'components/Button'
import { SuccessContainer, SuccessTitle, SuccessMessage } from '../style'

export const RenderSuccessMessage = (handleNewImport) => {
  return (
    <SuccessContainer>
      <SuccessTitle>Processamento Concluído!</SuccessTitle>
      <SuccessMessage>
        O arquivo foi processado com sucesso e o download do resultado foi
        iniciado. As URLs personalizadas foram geradas para cada cliente da sua
        planilha.
      </SuccessMessage>

      <div
        style={{
          display: 'flex',
          gap: '12px',
          marginTop: '20px',
          flexWrap: 'wrap'
        }}
      >
        <RoundedButton
          whiteTextLabel
          type="upload"
          size="large"
          variant="contained"
          onClick={handleNewImport}
          text="Fazer Novo Import"
        />
      </div>
    </SuccessContainer>
  )
}
